module.exports = __webpack_public_path__ + "img/Mai.6fb663c8.png";